export const WORKFLOW_MONITORING_PATH = '/workflow-monitoring';

export const HANDLING_STATUS_FIELD = 'handlingStatus';

export const MONITORING_TIME_RANGES_DAYS = [3, 7, 14, 21];
export const DEFAULT_MONITORING_DAYS = 3;

export const MAX_SELECTED_EXECUTIONS = 50;
export const BULK_ACTION_CONCURRENCY = 4;

export const EXECUTIONS_PAGE_SIZE = 1000;
export const MAX_ERROR_EXECUTIONS = 5000;
export const MAX_WORKFLOW_EXECUTIONS = 1000;

export const TOP_WORKFLOWS_IN_CHART = 5;

export const CHART_SERIES_COLORS = ['#2A78D6', '#1BAF7A', '#EDA100', '#E87BA4', '#4A3AA7'];
export const CHART_OTHER_COLOR_VARIABLE = '--primary-color-disabled';
export const CHART_MUTED_COLOR_VARIABLE = '--light-grey';
